import { FunctionContext, SharedFunctionContext } from './FunctionContext';
import { FunctionLibrary } from './FunctionDefinition';
import { BOOLEAN_FUNCTIONS } from './functions/boolean';
import { COMPARISON_FUNCTIONS } from './functions/comparison';
import { DATES_AND_TIMES_FUNCTIONS } from './functions/datesAndTimes';
import { LOAN_FUNCTIONS, LOAN_WORKFLOW_FUNCTIONS } from './functions/loan';
import { LOGICAL_FUNCTIONS } from './functions/logical';
import { MATH_FUNCTIONS } from './functions/math';
import { STRING_FUNCTIONS } from './functions/strings';
import { WORKFLOW_FUNCTIONS } from './functions/workflow';

// Functions every evaluator can run — they read only loan + time context. This is exactly the set
// the email evaluator exposes. Typing it as a shared-context library means a workflow-only function
// (which needs `FunctionContext`) cannot be added here without a compile error.
export const SHARED_FUNCTIONS = {
  ...BOOLEAN_FUNCTIONS,
  ...MATH_FUNCTIONS,
  ...DATES_AND_TIMES_FUNCTIONS,
  ...COMPARISON_FUNCTIONS,
  ...STRING_FUNCTIONS,
  ...LOGICAL_FUNCTIONS,
  ...LOAN_FUNCTIONS,
} satisfies FunctionLibrary<SharedFunctionContext>;

// Everything the workflow evaluator can run: the shared set plus functions that read workflow state.
export const WORKFLOW_EVALUATOR_FUNCTIONS = {
  ...SHARED_FUNCTIONS,
  ...WORKFLOW_FUNCTIONS,
  ...LOAN_WORKFLOW_FUNCTIONS,
} satisfies FunctionLibrary<FunctionContext>;

// The full language the parser recognizes (the workflow superset). Used only for parse-time type
// resolution and unknown-function rejection — which functions can actually *run* is decided
// per-evaluator by the two registries above.
export const ALL_PARSEABLE_FUNCTIONS: FunctionLibrary<FunctionContext> = WORKFLOW_EVALUATOR_FUNCTIONS;
